var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.brandLogo)?_c('span',{staticClass:"brand-badge"},[_c('img',{attrs:{"src":require(`@/assets/images/common/element-icons-logo-${_vm.badge.name}.svg`),"width":_vm.badge.width,"height":_vm.badge.height,"alt":`${_vm.badge.name} Logo`}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }